import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setTitle('Click&Collect')
        .setChildren([
            MenuEntry.create()
                .setRoute('checkout_schedule_calendar'),
            MenuEntry.create()
                .setRoute('click_and_collect_collect_bin_clearing'),
            MenuEntry.create()
                .setTitle('Einstellungen')
                .setChildren([
                    MenuEntry.create()
                        .setRoute('checkout_schedule_weekday_config'),
                    MenuEntry.create()
                        .setRoute('checkout_schedule_availability_config'),
                ]),
        ]),
];
